package music.jammers.client.shared.event.track.domain.usecase

import music.jammers.client.shared.event.track.domain.repository.EventTrackRepository
import music.jammers.shared.event.track.domain.model.EventTrack

class GetEventTrackUseCase(
    private val eventTrackRepository: EventTrackRepository,
) {

    suspend operator fun invoke(id: Long): EventTrack =
        eventTrackRepository.get(id)
}